module.exports = __webpack_public_path__ + "kopriva_nettle_tea_paper_mockup.png?3efceaab43e980d754b549d07f65f808";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/kopriva_nettle_tea_paper_mockup.png
// module id = 76
// module chunks = 0